import { SegmentedControl } from "../../UI/SegmentedControl.tsx";

export function ChoiceControl<Value extends string>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { value: Value; label: string }[];
  value: Value;
  onChange: (value: Value) => void;
}) {
  return (
    <>
      <select
        aria-label={label}
        value={value}
        onChange={(event) => onChange(event.target.value as Value)}
        className="sm:hidden h-8 rounded-lg border border-slate-200 bg-white pl-2 pr-7 text-xs text-slate-700"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="hidden sm:block">
        <SegmentedControl options={options} value={value} onChange={onChange} />
      </div>
    </>
  );
}
